import React, { forwardRef, memo } from 'react'

const CartIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      {...props}>
      <circle
        cx="28"
        cy="28"
        r="26.871"
        fill="#fff"
        stroke="#EEE"
        strokeWidth="2.259"
      />
      <path
        d="M33.25 32.9h-8.473a1.45 1.45 0 0 1-1.377-1.15L21.064 18.9H18.9M24.85 36.4a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM33.25 36.4a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM22.973 29.4h10.986a1.45 1.45 0 0 0 1.377-1.15L36.4 22.4H21.7"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

CartIcon.displayName = 'CartIcon'

export default memo(CartIcon)
